<template>
  <div class='CardInfo'>
    <div class="SearchForm">
      <el-select v-model="searchOptions"
                 placeholder="请选择">
        <el-option v-for="item in options"
                   :key="item.value"
                   :label="item.label"
                   :value="item.value">
        </el-option>
      </el-select>
      <el-input v-model="SearchInput"
                class="SearchInput"
                :placeholder="placeholder"></el-input>
      <el-button type="primary"
                 class="SearchBtn"
                 size="medium" 
                 @click="getSolaCard">查询</el-button>
    </div>

    <div class="card-lock" v-if="showLock">
      <div class="lock-flex">
        <div>会员ID：</div>
        <div style="margin: 0 20px;">{{account }}</div>
        <el-button type="danger"
                 size="mini" 
                 @click="updateLockStatus(false)"
                 v-if="accountInfo.lockStatus"
                 >解锁</el-button>
      <el-button type="primary"
                 size="mini" 
                 @click="updateLockStatus(true)"
                 v-else
                 >锁定</el-button>

      </div>
      <el-divider></el-divider>
      <div class="lock-flex">
        <div class="mr-20">特殊支付限额设置：</div>
        <div class="mr-10"><el-input size="small" v-model="accountInfo.payLimit" ></el-input></div>
        <div class="mr-20">元/笔</div>
        <div class="mr-10"><el-input size="small" v-model="accountInfo.dayLimitAmount"></el-input></div>
        <div class="mr-20">元/日</div>
        <div class="mr-10"><el-input size="small" v-model="accountInfo.monthLimitAmount"></el-input></div>
        <div class="mr-20">元/月</div>
        <div class="mr-10"><el-input size="small" v-model="accountInfo.yearLimitAmount"></el-input></div>
        <div class="mr-20">元/年</div>
        <el-button type="primary"
                 size="mini"
                 @click="updateLimit" 
                 >保存</el-button>
      </div>
    </div>

    <Table :TableParam="Table">
      <template v-slot:handle="{ item }">
        <el-link type="primary"
                 @click="()=>actionLockingCard(item)"
                 v-if="[2,4].includes(item.state.value)">{{ item.state.value === 2 ? '锁定' : '解锁' }}</el-link>
        <el-link type="primary" @click="delayFun(item)" v-if="item.state.value === 3">延期</el-link>
      </template>

    </Table>
    <service-dialog :show.sync="delayDialog.show"
                    @handle="delayDialog.confirm"
                    :title="delayDialog.title">
      <template v-slot:dialogContent>
        <div class="content">
          <span class="demonstration">有效期截止时间：</span>
          <el-date-picker v-model="delayDialog.validTime"
                          class="hideIcon"
                          size="small"
                          type="date"
                          placeholder="结束日期"
                          value-format="yyyy-MM-dd"
                          :picker-options="delayDialog.pickerOptionsEnd">
          </el-date-picker>
        </div>
      </template>
    </service-dialog>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import Table from '@/components/Table'
import serviceDialog from '@/components/Dialog'
export default {
  // import引入的组件需要注入到对象中才能使用 
  components: {
    Table,
    serviceDialog
  },
  data () {
    // 这里存放数据
    return {
      account: '',
      accountInfo: {},
      showLock: false,
      SearchInput: '',
      searchOptions: 1,
      options: [{ value: 1, label: '卡编号' }, { value: 2, label: '会员卡号' }],
      cardNatureObj:{
        0: '定额卡',
        1: '不定额卡',
        2: '动态充值卡'
      },
      Table: { // 表格
        handle: true,
        data: [],
        column: [
          { prop: 'batchSn', label: '批次号' },
          { prop: 'cardNatureName', label: '卡种类' },
          { prop: 'cardName', label: '卡名称' },
          { 
            prop: 'cardNo', label: '预付卡号', type: 'event', handle: (res) => {
              this.$router.push({ path: 'cardCheckInfo', query: { id: res.id } })
            }
          },
          { prop: 'bindAccount', label: '会员卡号' },
          { prop: 'cardTypeName', label: '卡类型' },
          { prop: 'denomination', label: '面值（元）' },
          { prop: 'remaining', label: '余额' },
          { prop: 'validPeriod', label: '有效期' },
          { prop: 'state', label: '状态' },
          { prop: 'updateTime', label: '更新日期' }
        ]

      },
      delayDialog: { // 延后的弹窗
        show: false,
        title: '延期',
        confirm: this.delayDialogConfirm,
        oldValidTime: null,
        validTime: null,
        targetId: null,
        pickerOptionsEnd: {
          disabledDate: time => {
            const beginDateVal = this.delayDialog.oldValidTime
            if (beginDateVal) {
              return (
                time.getTime() < new Date(beginDateVal).getTime()
              )
            }
          }
        }
      }
    }
  },
  // 监听属性 类似于data概念
  computed: {
    placeholder: {
      get () {
        return this.searchOptions === 1 ? '请输入卡编号' : '请输入会员卡号'
      }
    }
  },
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    updateLockStatus(lockStatus) {
      let params = {
        account: this.account,
        lockStatus,
      }
      this.$http.accountLimitLockApi(params).then(res => {
        if (res.status === 200) {
          this.$message.success(res.msg)
          this.getAccountLimitInfo()
          }
      })
    },
    updateLimit() {
      let {accountName, dayLimitAmount, monthLimitAmount, payLimit, yearLimitAmount} = this.accountInfo
      let params = {
        account: this.account,
        accountName,
        dayLimitAmount,
        monthLimitAmount,
        payLimit,
        yearLimitAmount,
      }
      this.$http.accountLimitUpdateApi(params).then(res => {
        if (res.status === 200) {
          this.$message.success(res.msg)
          this.getAccountLimitInfo()
          }
      })
    },
    getAccountLimitInfo () {
      let params = {
        account: this.account
      }
      this.$http.accountLimitInfoApi(params).then(res => {
        if (res.status === 200) {
            this.accountInfo = res.data || {}
          }
      })
    },
    getSolaCard () {
      const { Table, searchOptions, SearchInput } = this
      const params = {}
      searchOptions === 1 ? params.cardNo = SearchInput : params.accountNo = SearchInput
      this.$http.getSolaCard(params)
        .then((res) => {
          if (res.status === 200) {
            if (res.data == null) return
            if (searchOptions == 1 && res.data.length) {
              this.account = res.data[0].bindAccount
              this.showLock = !!res.data[0].bindAccount
            } else {
              this.account = SearchInput
              this.showLock = !!res.data.length
            }
            this.getAccountLimitInfo(this.account)
            if (!res.data.bindAccount) {
              res.data.bindAccount = '-'
            }
            res.data.forEach(element => {
              element.cardNatureName =  this.cardNatureObj[element.cardNature]
            });
            // res.data.map(item=>{
            //   return {
            //     ...item,
            //     cardNatureName: this.cardNatureObj[item.cardNature]
            //   }
            // })
            Table.data = res.data || []
          }
        })
    },
    // 锁定或者解锁
    actionLockingCard (row) {
      const API = row.state.value === 2 ? 'lockingCard' : 'unlockCard'
      const param = {
        id: row.id
      }
      this.$http[API](param)
        .then((res) => {
          if (res.status === 200) {
            this.$message.success(res.msg)
            this.getSolaCard()
          }
        })
    },
    // 延期
    delayFun (item) {
      const { id, validEnd } = item
      this.delayDialog.targetId = id
      this.delayDialog.oldValidTime = validEnd
      this.delayDialog.validTime = validEnd
      this.delayDialog.show = true
    },
    delayDialogConfirm () {
      const param = {
        id: this.delayDialog.targetId,
        validEnd: this.delayDialog.validTime
      }
      this.$http.extensionCard(param)
        .then((res) => {
          if (res.status === 200) {
            this.$message.success(res.msg)
            this.delayDialog.show = false
            this.getSolaCard()
          } else {
            this.$message.error(res.msg)
          }
        })
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {

  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {

  },
  beforeCreate () { }, // 生命周期 - 创建之前
  beforeMount () { }, // 生命周期 - 挂载之前
  beforeUpdate () { }, // 生命周期 - 更新之前
  updated () { }, // 生命周期 - 更新之后
  beforeDestroy () { }, // 生命周期 - 销毁之前
  destroyed () { }, // 生命周期 - 销毁完成
  activated () { } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
.CardInfo {
  ::v-deep .SearchForm {
    margin: 20px;
    height: 100px;
    background-color: #fff;
    border-radius: 10px;
    padding: 0 100px;
    box-sizing: border-box;
    .SearchInput {
      width: 500px;
      line-height: 100px;
    }
    .SearchBtn {
      margin-left: 20px;
    }
    .el-select {
      width: 120px;
      margin-right: 10px;
    }
  }
}
.card-lock {
  background-color: #fff;
  margin: 20px;
  margin-top: 0;
  padding: 20px;
}
.lock-flex {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.mr-10 {
  margin-right: 10px;
}
.mr-20 {
  margin-right: 20px;
}
</style>
